
























import { io } from "socket.io-client";
import Cookies from "js-cookie";
import { useNotificationStore } from "../app/notificationStore";
import notificationSound from "../assets/notification.mp3";
import { useState } from "react";
import { X, Send } from "lucide-react";
import toast from "react-hot-toast";

const IMAGE_BASE_URL = "https://uptask.visiontrek.io";

 
let socket;
 
// 🛸 --- QUICK REPLY TOAST COMPONENT ---
const QuickReplyToast = ({ t, data, socket }) => {
  const [reply, setReply] = useState("");

  const handleQuickReply = (e) => {
    e.preventDefault();
    if (!reply.trim()) return;
    
    if (socket) {
      socket.emit("send_message", {
        receiverId: data.senderId,
        message: reply,
        clientTime: new Date()
      });
      toast.success("Reply sent!", { id: `reply_success_${t.id}` });
    }
    toast.dismiss(t.id);
  };


const senderName =
data.senderName || 
`${data.sender_first_name || ""} ${data.sender_last_name || ""}`.trim() ||
"User";

const senderProfilePic =
data.senderProfilePic || data.sender_profile_pic;

  return (
    <div

    onClick={() => {
      // ✅ store which chat to open
      localStorage.setItem(
        "openChatFromNotification",
        JSON.stringify({
          userId: data.senderId,
        })
      );

      // ✅ redirect to chat page (or dashboard where chat exists)
      window.location.href = "/"; // or "/chat" if you have route

      toast.dismiss(t.id);
    }}
      className={`${
        t.visible ? 'animate-in slide-in-from-right' : 'animate-out slide-out-to-right'
      } max-w-sm w-full bg-[#1b1d29] shadow-[0_20px_50px_rgba(0,0,0,0.5)] rounded-2xl pointer-events-auto flex flex-col p-4 border border-white/10 overflow-hidden relative`}
    >
      <div className="absolute bottom-0 left-0 h-1 bg-indigo-500 animate-[progress_5s_linear]" />

      <div className="flex items-center gap-3">
        <div className="w-11 h-11 rounded-full bg-gradient-to-tr from-indigo-600 to-purple-600 flex items-center justify-center font-bold text-white overflow-hidden shadow-lg shrink-0 border-2 border-white/10">
          {/* {data.senderProfilePic ? (
            <img src={`https://uptask.visiontrek.io${data.senderProfilePic}`} alt="avatar" className="w-full h-full object-cover" />
          ) : (
            data.senderName ? data.senderName.charAt(0).toUpperCase() : "U"
          )} */}





{senderProfilePic ? (
  <img
    src={`https://uptask.visiontrek.io${senderProfilePic}`}
    className="w-full h-full object-cover"
  />
) : (
  senderName.charAt(0).toUpperCase()
)}



        </div>
        <div className="flex-1">
          <p className="text-[13px] font-black text-white tracking-tight">
            {data.senderName || "User"}
          </p>
          <p className="text-[11px] text-white/60 mt-0.5 line-clamp-1 max-w-[220px] italic">
            "{data.message}"
          </p>
        </div>
        <button
          onClick={() => toast.dismiss(t.id)}
          className="p-1 rounded-md text-white/30 hover:text-white/100 transition-colors"
        >
          <X size={16} />
        </button>
      </div>
      
      <form onSubmit={handleQuickReply}
        onClick={(e) => e.stopPropagation()} 
      
      className="mt-4 flex gap-2">
        <input 
          type="text"
          autoFocus
          value={reply}
          onChange={(e) => setReply(e.target.value)}
          placeholder="Type a quick reply..."
          className="flex-1 bg-white/5 border border-white/10 rounded-xl py-2 px-3 text-[12px] text-white outline-none focus:border-indigo-500/50 transition-colors"
        />
        <button
          type="submit"
          className="bg-indigo-600 hover:bg-indigo-500 text-white p-2 rounded-xl transition-all active:scale-95 shadow-lg shadow-indigo-600/20"
        >
          <Send size={16} />
        </button>
      </form>
    </div>
  );
};

export const getSocket = () => socket;
 
// export function connectSocket() {
  export function connectSocket() {
    if (socket) {
      console.log("⚠️ Socket already exists");
      return socket;
    }


 
  const audio = new Audio(notificationSound);
  audio.volume = 0.7;
 
  // Unlocks audio context on first user interaction so it can autoplay later
  const unlockAudio = () => {
    audio.play().then(() => {
      audio.pause();
      audio.currentTime = 0;
      console.log("🔊 Audio Unlocked for this session");
    }).catch(() => {});
    document.removeEventListener('click', unlockAudio);
    document.removeEventListener('keydown', unlockAudio);
  };
  document.addEventListener('click', unlockAudio);
  document.addEventListener('keydown', unlockAudio);
 
 
  const token = Cookies.get("token") || localStorage.getItem("token");
  if (!token) return;
 
  // socket = io("http://88.99.5.236:5555", {
    // socket = io("http://localhost:6655", {
      // const BASE_URL = "http://192.168.1.16:5555/api";

    socket = io("https://uptask.visiontrek.io", {
   
      // 192.168.1.16
    auth: { token },
  });
 
  // socket.on("connect", () => {
  //   console.log("🟢 Socket connected:", socket.id);
  // });
 
 
socket.on("connect", () => {
  console.log("🟢 Socket connected:", socket.id);
 
  const user = JSON.parse(localStorage.getItem("user"));
 
  if (user?.id) {
    socket.emit("join", `user_${user.id}`); // ✅ FIXED
  }
});
 
 
 
 
  socket.on("notification", (data) => {
    console.log("🔔 Notification (raw):", data);
 
      // 🔊 PLAY SOUND
  audio.currentTime = 0;   // restart sound if already playing
  audio.play().catch((err) => {
    console.log("Autoplay blocked:", err);
  });
 
 
    // 🧠 Extract employee info from message
    // eslint-disable-next-line no-unused-vars
    let employeeName = "Employee";
    let employeeId = null;
 
    if (typeof data.message === "string") {
      const match = data.message.match(/Employee\s+#(\d+)/);
      if (match) {
        employeeId = match[1];
        employeeName = `Employee ${employeeId}`;
      }
    }
 
 



    const formattedNotification = {
      id: `${data.type}_${Date.now()}`,
      type: (data.type || "general").toLowerCase(),
    
      message:
        data.type === "leave"
          ? `${data.userdata?.first_name || ""} ${data.userdata?.last_name || ""} applied for leave`
          : data.message || "New notification",
    
      leaveType: data.leave_type || "",
    
      // ✅ KEEP OLD
      userdata: data.userdata || null,
    
      // ✅ ADD THIS (VERY IMPORTANT)
      sender_profile_pic: data.sender_profile_pic || null,
    
      redirectTo:
        data.type === "leave"
          ? "/leaves/pending"
          : data.type === "TASK_ASSIGNED" || data.type === "task_assigned"
          ? "/tasks/assigned"
          : data.type === "EMPLOYEE OF THE MONTH" || data.type === "EMPLOYEE_OF_THE_MONTH"
          ? "/"
          : "/",
    
      createdAt: Date.now(),
    };

    // Special celebratory toast for Employee of the Month
    if (data.type === "EMPLOYEE OF THE MONTH" || data.type === "EMPLOYEE_OF_THE_MONTH") {
      toast.success(
        (t) => (
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 rounded-full overflow-hidden border-2 border-yellow-400 shadow-lg">
              {data.userdata?.winnerPic ? (
                <img 
                  src={`${IMAGE_BASE_URL}${data.userdata.winnerPic}`} 
                  alt="Winner" 
                  className="w-full h-full object-cover"
                />
              ) : (
                <div className="w-full h-full bg-yellow-400 flex items-center justify-center text-white font-bold">
                  🌟
                </div>
              )}
            </div>
            <div>
              <p className="font-bold text-gray-900 dark:text-white">🌟 {data.title}</p>
              <p className="text-sm text-gray-600 dark:text-gray-300">{data.message}</p>
            </div>
          </div>
        ),
        { duration: 6000, position: "top-center" }
      );
    }
 
    useNotificationStore.getState().addNotification(formattedNotification);
  });
 
  socket.off("receive_message"); // ✅ ADD THIS


  socket.on("receive_message", (data) => {
    const user = JSON.parse(localStorage.getItem("user") || "{}");
  
    if (data.senderId === user.id) return;
  
    const { activeChatId, activeGroupId } = useNotificationStore.getState();
  
    const isRoomOpen = data.groupId
      ? activeGroupId === data.groupId
      : activeChatId === data.senderId;
  
    if (isRoomOpen) return;
  
    // 🔊 sound
    audio.currentTime = 0;
    audio.play().catch(() => {});
  
    useNotificationStore.getState().incrementChatUnread();
  
    const isTabActive = document.visibilityState === "visible";
  
    const senderName =
      data.senderName ||
      `${data.sender_first_name || ""} ${data.sender_last_name || ""}`.trim() ||
      "New Message";
      // console.log('message',message)
  
    let senderProfilePic = null;
  
    if (data.senderProfilePic) {
      senderProfilePic = `${IMAGE_BASE_URL}${data.senderProfilePic}`;
    } else if (data.sender_profile_pic) {
      senderProfilePic = `${IMAGE_BASE_URL}${data.sender_profile_pic}`;
    } else {
      senderProfilePic = `${IMAGE_BASE_URL}/default-avatar.png`;
    }
  
    if (isTabActive) {
      toast.custom(
        (t) => <QuickReplyToast t={t} data={data} socket={socket} />,
        { duration: 5000, position: "bottom-right" }
      );
    } else {
      if (Notification.permission === "granted") {
        const notification = new Notification(senderName, {
          body: data.message,
          icon: senderProfilePic,
          silent: true, // Prevent browser from playing its own sound
        });
  
        notification.onclick = () => {
          window.focus();
        
          // store data temporarily
          localStorage.setItem(
            "openChatFromNotification",
            JSON.stringify({
              userId: data.senderId,
            })
          );
        
          window.location.href = "/"; // go to main app
        };
      }
    }
  });

  // Listener for dynamic group joining
  socket.on("added_to_group", (data) => {
    socket.emit("join_group", { groupId: data.groupId });
  });
 
socket.on("disconnect", () => {
    console.log("🔴 Socket disconnected");
  });
}
 
export function disconnectSocket() {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
}
